import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import SEO from "@/components/SEO";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);

    // Signal a 404 status to prerender services and crawlers that respect
    // the prerender-status-code convention. SPAs can't set a real HTTP
    // status, but this is the de-facto standard for marking soft 404s.
    const meta = document.createElement("meta");
    meta.name = "prerender-status-code";
    meta.content = "404";
    document.head.appendChild(meta);
    return () => {
      meta.remove();
    };
  }, [location.pathname]);

  return (
    <div className="min-h-dvh bg-background flex flex-col">
      <SEO
        title="Page Not Found | GetPetVet"
        description="The page you're looking for doesn't exist. Head back to GetPetVet to find a vet, book a video consult or manage your pet's records."
        noindex
      />
      <Navbar />
      <main className="flex-1 flex items-center justify-center">
        <div className="text-center">
          <h1 className="mb-4 text-4xl font-bold">404</h1>
          <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
          <Link to="/" className="text-primary underline hover:text-primary/90">
            Return to Home
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
